import styled from 'styled-components';
import { ToolTip } from '../..';
import Copy from '../../copy/Copy';
import { TransparentButton } from '../../transparent-button/TransparentButton';
export const CustomCopyButton = styled(Copy) `
  padding: 0.7rem;
  height: min-content;

  word-break: normal;

  margin-left: 2rem;
`;
export const DestinationDetailsWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  ${({ theme }) => theme.media.laptop `
    flex-direction: row;
  `};
`;
export const SwapDestinationDetailsContainer = styled.div `
  position: relative;

  padding: 1.8rem 2.2rem;
  margin: 1.6rem;

  box-shadow: ${({ theme }) => theme.shadows.sm};

  border-radius: ${({ theme }) => theme.borderRadius.highM};

  background-color: ${({ theme }) => theme.colors.surface.default};

  ${({ theme }) => theme.media.tabletL `
    margin: 2rem 0;
    padding: 2.4rem 4rem;
  `};
`;
export const QrBackgroundWrapper = styled.div `
  margin-bottom: 2rem;
  padding: 0.8rem;

  border-radius: ${({ theme }) => theme.borderRadius.highM};

  background: linear-gradient(180deg, #2869f4 0%, #3049b5 100%);

  ${({ theme }) => theme.media.laptop `
     padding: 1.6rem;
     margin-bottom: 0;
     margin-right: 1.8rem;
  `};
`;
export const QrWrapper = styled.div `
  height: 12rem;
  width: 12rem;

  padding: 1rem;

  border-radius: ${({ theme }) => theme.borderRadius.high};

  background-color: ${({ theme }) => theme.colors.text.interactive};

  ${({ theme }) => theme.media.laptop `
    height: 24rem;
    width: 24rem;

    padding: 2rem;
  `};
`;
export const DestinationDetails = styled.div `
  display: flex;
  flex-direction: column;

  width: 100%;
`;
export const SwapDetailsField = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;

  word-break: break-all;

  padding: 2rem;

  border-radius: ${({ theme }) => theme.borderRadius.high};

  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};

  &:not(:last-child) {
    margin-bottom: 1.2rem;
  }

  ${({ theme }) => theme.media.laptop `
    &:not(:last-child) {
      margin-bottom: 0.9rem;
    }
  `}
`;
export const RateInfoWrapper = styled.div `
  display: flex;
  gap: 0.4rem;
`;
export const CustomToolTip = styled(ToolTip) `
  .tooltip {
    width: 21.5rem;
    left: -8rem;
    white-space: pre-wrap;
    word-break: break-word;
    &:after {
      left: calc(86% - 1.05rem);
    }
  }
`;
export const LinkIconWrapper = styled(TransparentButton) `
  display: flex;
  align-items: center;
  justify-content: center;

  width: 3.8rem;
  height: 3.8rem;

  border-radius: ${({ theme }) => theme.borderRadius.highM};

  background-color: ${({ theme }) => theme.colors.surface.default};
`;
export const SwapStepContainer = styled.div `
  padding: 3rem 4rem 3.4rem;
  width: 100%;
  margin-top: 2rem;
  background-color: ${({ theme }) => theme.colors.background.light};
  border-radius: ${({ theme }) => theme.borderRadius.highM};
  ${({ theme }) => theme.media.laptop `
    padding: 2.6rem 9rem 3.6rem;
  `}
`;
export const ScrollToWrapper = styled(TransparentButton) `
  position: absolute;

  left: calc(100% - 1rem);
  top: 4.4rem;
  transform: translateX(-100%);

  display: flex;
  align-items: center;
  justify-content: center;

  min-height: 6rem;
  min-width: 6rem;

  border: 1px solid ${({ theme }) => theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.highest};

  background-color: ${({ theme }) => theme.colors.surface.default};

  ${({ theme }) => theme.media.laptop `
    left: calc(100% + 1.6rem);
    top: 20%;
    transform: translateX(0);
  `}
`;
export const AmountWrapper = styled.div `
  position: absolute;
  top: 0;
  right: 0;

  transform: translate(20%, -20%);

  display: flex;
  align-items: center;
  justify-content: center;

  min-height: 2rem;
  min-width: 2rem;

  border: 1px solid ${({ theme }) => theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.highest};

  background-color: ${({ theme }) => theme.colors.interactive.critical};
`;
//# sourceMappingURL=styles.js.map